import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

interface AuditEntry {
  _id: string;
  adminId: string;
  action: string;
  target: string;
  at: string;
}

export default function AuditLog() {
  const { data } = useQuery<{ items: AuditEntry[] }>({
    queryKey: ['admin', 'audit'],
    queryFn: () => api('/api/v1/admin/audit-log'),
  });
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Audit log</h1>
      <div className="bg-surface border border-border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-surface2 text-left text-text2">
            <tr>
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Admin</th>
              <th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">Target</th>
            </tr>
          </thead>
          <tbody>
            {(data?.items ?? []).map((e) => (
              <tr key={e._id} className="border-t border-border">
                <td className="px-4 py-3 text-text2">{new Date(e.at).toLocaleString()}</td>
                <td className="px-4 py-3 font-mono text-xs">{e.adminId}</td>
                <td className="px-4 py-3 font-semibold text-accent">{e.action}</td>
                <td className="px-4 py-3 font-mono text-xs">{e.target}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
